<template>
  <div>
    <div class="jazeModalContainer jazeModalContainer--blackout jazeModalContainer--centered" dialog-layout="speedTestLayout" v-show="allowIpModalShow" style="display:flex">
      <div class="pos-relative" dialog-window>
        <div dialog-content>
          <div class="jazeModal jazeModal--small unifiSpeedTestModal unifiSpeedTestModal--inProgress">
            <form class="jazeForm jazeModal jazeModal--small unifiAddUser">
              <div class="jazeModal__header pb-0">
                <div class="jazeHeader jazeHeader--centered">
                  <div class="jazeHeader__title">Add IP</div>
                  <svg viewBox="0 0 14 14" class="jazeIcon jazeIcon--actionable" @click="onclose">
                    <g transform="translate(8.5 7.2071) rotate(45) translate(-9 -9)">
                      <path d="m9.0294 8.7071h8v1h-8v8h-1v-8h-8v-1h8v-8h1v8z" />
                    </g>
                  </svg>
                </div>
              </div>
              <form ref="connectForm" :class="formClass">
                <div class="jazeModal__main">

                  <div class="jazeModalContent pb-1">
                    <fieldset class="appFieldset appFieldset--quiet">
                      <div class="form-group appRow">
                        <div class="col--sm4">
                          <label class="appLabel appLabel--primary appLabel--boxInline">IP Address</label>
                        </div>
                        <div class="col--sm8 appFormGroup appFormGroup--cozy">
                          <input type="text" class="width-full" required="required" v-model="IPAddress">
                        </div>
                      </div>
                      <div class="form-group appRow">
                        <div class="col--sm4">
                          <label class="appLabel appLabel--primary appLabel--boxInline">Network Mask</label>
                        </div>
                        <div class="col--sm8 appFormGroup appFormGroup--cozy">
                          <select class="width-full" v-model="netMask" @change="onChange($event)">
                            <option v-for="i in 32" :key="i" :value="i" v-show="i != 31">{{ i }}</option>
                          </select>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                </div>
              </form>
              <div class="jazeModal__footer">
                <div class="jazeButtonGroup jazeButtonGroup--cozy">
                  <button class="jazeButton jazeButton--secondary" @click="onclose">Cancel</button>
                  <button class="jazeButton jazeButton--primary" type="submit" @click="extendSubmit">Add</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <SuccessToaster :successMessage='successMessage' :sucesstoasterShow='successtoaster' v-if='successtoaster'></SuccessToaster>
    <ErrorToaster :errorMessage='errorMessage' :errortoasterShow='errortoaster' v-if='errortoaster'></ErrorToaster>
  </div>
</template>
<script setup>
import Nprogress from "nprogress";
import axios from "@/api/index";
import Treeselect from "jaze-vue3-treeselect";
import SuccessToaster from "@/components/Toaster/SuccessToaster.vue";
import ErrorToaster from "@/components/Toaster/ErrorToaster.vue";
import { useaccountsettingStore } from '@/store/accountsettingstore';
import { usesettingsStore } from '@/store/settingsstore'
import {ref,toRef,defineProps,defineEmits,watch,computed,onMounted} from 'vue';

  const emit = defineEmits(['extend-clicked-allowip-detail']);
  const props = defineProps(["adminId", "accountId", "email", "userName", "fromwhere"]);

  const accountsettingStore = useaccountsettingStore();
  const settingStore = usesettingsStore();
  const adminId=toRef(props,'adminId');
  const accountId=toRef(props,'accountId');
  const email=toRef(props,'email');
  const userName=toRef(props,'userName');
  const fromwhere=toRef(props,'fromwhere');

  const formClass = ref('appForm appForm--cozy is-validation-hidden');
  const allowIpModalShow = ref(true);
  const successtoaster = ref(false);
  const successMessage = ref('');
  const errorMessage = ref('');
  const errortoaster = ref(false);
  const netMask = ref(null);
  const IPAddress = ref(null);


  const onclose = ()=> {
    allowIpModalShow.value = false;
    emit("extend-clicked-allowip-detail", allowIpModalShow.value);
  };
  const onChange = (event)=> {
    netMask.value = event.target.value;
  };
  const extendSubmit = (e)=> {
    e.preventDefault();
    const postData = {};
    if(fromwhere.value != undefined && fromwhere.value == "api") {
      postData.ipAddress = IPAddress.value;
      postData.networkMask = netMask.value;
      settingStore.allowApiIPAddress(postData).then(  
        (response) => {
          allowIpModalShow.value = false;
          successtoaster.value = true;
          successMessage.value = response.genericBody;
          setTimeout(
            function () {
              successtoaster.value = false;
              emit("extend-clicked-allowip-detail", false);
            }.bind(this),
            1500
          );
        },
        (error) => {
          errortoaster.value = true;
          allowIpModalShow.value = false;
          errorMessage.value = error;
          setTimeout(
            function () {
              errortoaster.value = false;
            }.bind(this),
            1500
          );
          console.log(error);
        }
      );
    } else {
      postData.adminId = adminId.value;
      postData.accountId = accountId.value;
      postData.ipAddress = IPAddress.value;
      postData.networkMask = netMask.value;
      postData.adminEmail = email.value;
      postData.adminUsername = userName.value;
      // $store.dispatch("allowIPAddress", postData).then(
      accountsettingStore.allowIPAddress(postData).then(  
        (response) => {
          allowIpModalShow.value = false;
          successtoaster.value = true;
          successMessage.value = response.genericBody;
          setTimeout(
            function () {
              successtoaster.value = false;
              emit("extend-clicked-allowip-detail", false);
            }.bind(this),
            1500
          );
        },
        (error) => {
          errortoaster.value = true;
          allowIpModalShow.value = false;
          errorMessage.value = error;
          setTimeout(
            function () {
              errortoaster.value = false;
            }.bind(this),
            1500
          );
          console.log(error);
        }
      );
    }
  };

</script>